import Vue from "vue";
import Vuex from "vuex";
import CreatePersistedState from "vuex-persistedstate";
import user from "./modules/user";
import theme from "./modules/theme";
import adv from "./modules/adv";
import popupInfo from "./modules/popupInfo";
import hotspot from "./modules/hotspot";
import hotspotTheme from "./modules/hotspotTheme";
import global from "./modules/global";
import news from "./modules/news";
import wifiAuth from "./modules/wifiAuth";
import statistics from "./modules/statistics";
import poll from "./modules/poll";
import tariff from "./modules/tariff";
import hint from "./modules/hint";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [
    // записывает в localStorage состояния из store
    CreatePersistedState({
      paths: ["global.themeDark", "hotspot.timerHotspot", "hint.hintActive"]
    })
  ],

  modules: {
    user,
    theme,
    adv,
    popupInfo,
    hotspot,
    hotspotTheme,
    global,
    wifiAuth,
    news,
    statistics,
    poll,
    tariff,
    hint
  }
});
